import "../style/presentation.css";

export default function PresentationSection() {
    return (
        <section className="presentation">              
            <div className="block">
            <img
                    className="sod-round-text"
                    src="../assets/pictures/sod.png"
                    alt="The sanctuary of dreams"
                />
                <p>
                    Conceived by polymath artist Pierre-Christophe Gam, <span className="italic">The Sanctuary of Dreams</span> is a metaverse multi-user dream world, fusing Art, music, animation and storytelling to support a Future-dreaming ritual through which participants can envision desirable future scenarios guided by their innermost desires. This immersive installation amalgamates a mixed media art installation, a metaverse dream world, a digital divination portal, and a multimedia platform dedicated to exploring the future.
                </p>
                <p>
                    It takes the form of a digital temple composed of five buildings, built around an open courtyard and nested within a lush, primordial garden. According to IFA, the ancient spiritual tradition of the Yoruba people (Nigeria, Benin, Togo etc), in order to achieve a truly satisfying and fulfilling life, one must consider five fundamental pillars: Ce-Meji pertains to the Body, Ka-Ogbe to the Mind, Gbe-Meji to the Spirit, Sa-Meji to the Heart and Yeku-Meji to the Soul. The pillars are introduced through the five buildings, in the format of mixed-media photo, 3D and digital collage animations, each considering the visible and the invisible dimension of their corresponding principle.
                </p>
            </div>
        </section>
    );
}
